module.exports = __webpack_public_path__ + "865d484a60e7eb2d854741c0a81683b7.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/minimal-wave-hat.png
 ** module id = 483
 ** module chunks = 0
 **/